<template>
    <v-container>
        <v-row justify="center">
            <v-col md="6">
                <v-row>
                    <v-col v-for="(service, index) in authorizedServices" :key="index" md="6">
                        <v-card @click="selectService(service)" class="service">
                            <v-card-title>{{ $t(service.name) }}</v-card-title>
                            <v-card-text>{{ $t(service.text) }}</v-card-text>
                            <v-icon class="goto">mdi-chevron-right</v-icon>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapMutations } from 'vuex';
import { NAVIGATION, SET_CURRENT_SERVICE } from '@constants/navigation';

export default {
    name: 'service-card',
    props: {
        services: Object
    },
    methods: {
        ...mapMutations(NAVIGATION, [SET_CURRENT_SERVICE]),
        selectService(service) {
            this.setCurrentService(service);
            this.$router.push(`${service.url}`);
        },
        checkAuthorizationForService(service) {
            if (service.url.startsWith('/userMgmt')) {
                return (
                    this.$store.state.aclConfig.userRoles?.serviceManager ||
                    this.$store.state.aclConfig.authorization?.superAdmin ||
                    this.$store.state.aclConfig.userRoles?.centralSupport ||
                    this.$store.state.aclConfig.userRoles?.HRManager ||
                    this.$store.state.aclConfig.userRoles?.manager ||
                    this.$store.state.aclConfig.userRoles?.standard
                );
            } else if (service.url.startsWith('/serviceMgmt')) {
                return (
                    this.$store.state.aclConfig.userRoles?.serviceManager || this.$store.state.aclConfig.authorization?.superAdmin
                );
            } else if (service.url.startsWith('/accMgmt')) {
                return (
                    this.$store.state.aclConfig.userRoles?.standard ||
                    this.$store.state.aclConfig.authorization?.superAdmin ||
                    this.$store.state.aclConfig.userRoles?.superAdmin
                );
            } else if (service.url.startsWith('/administration')) {
                return this.$store.state.aclConfig.authorization?.superAdmin;
            }
            return false;
        },
        checkServiceRedirection() {
            if (
                this.services &&
                Object.values(this.services).length === 1 &&
                this.checkAuthorizationForService(Object.values(this.services)[0])
            ) {
                this.selectService(Object.values(this.services)[0]);
            }
        }
    },
    computed: {
        authorizedServices() {
            const allowedServices = [];
            for (const [, service] of Object.entries(this.services)) {
                if (this.checkAuthorizationForService(service)) allowedServices.push(service);
            }
            return allowedServices;
        }
    },
    watch: {
        '$store.state.aclConfig': {
            handler() {
                this.checkServiceRedirection();
            },
            deep: true
        }
    },
    mounted() {
        this.checkServiceRedirection();
    }
};
</script>
<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.service {
    cursor: pointer;
    border-top: 7px solid #fff;
    .v-card__subtitle {
        padding-top: 10px;
        padding-bottom: 21px;
    }
    .goto {
        color: $primary;
        border-radius: 50% !important;
        position: absolute;
        right: 10px;
        bottom: 20px;
    }
    &:hover {
        border-top: 7px solid $primary;
        .goto {
            background-color: $primary;
            color: #fff;
        }
    }
}
</style>
